<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <div class="input-group">
              <input
                type="text"
                id="search-sources"
                aria-label="SearchSources"
                aria-describedby="SearchSources"
                placeholder="Search campaigns"
                class="form-control mr-2"
                v-model="searchWord"
              />
            </div>
            <button
              type="button"
              class="ml-auto btn btn-success"
              data-bs-toggle="modal"
              data-bs-target="#addCampaignModal"
            >
              Add Campaign
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">
                    <div class="d-flex align-items-center">Campaign ID</div>
                  </th>
                  <th scope="col">Medium</th>
                  <th style="width:23%" scope="col">Campaign</th>
                  <th scope="col">Candidates</th>
                  <th scope="col">Employers</th>
                  <th scope="col">Leads</th>
                  <th scope="col">Budget</th>
                  <th scope="col">CPC/Candidates</th>
                  <th scope="col">CPC/Employers</th>
                  <th scope="col">Start date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="campaign in campaigns" :key="campaign.id">
                  <th scope="row">
                    <div class="d-flex align-items-center">{{ campaign.campaign_id }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ campaign.medium }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ campaign.campaign }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ campaign.candidates_count }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ campaign.employers_count }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ campaign.leads_count }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      {{ `€ ${Number(campaign.budget)}` }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      {{ `€ ${campaign.candidates_cost.toFixed(2)}` }}
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">
                      {{ `€ ${campaign.employers_cost.toFixed(2)}` }}
                    </div>
                  </th>
                  <th>
                    {{
                      campaign.start_date
                        | formatDate({
                          format: getUserProfile.format_date,
                          timezone: getUserProfile.timezone,
                          hasHourAndMinutes: false,
                        })
                    }}
                  </th>
                  <th>
                    <button @click="handleEditClick(campaign)" class="btn btn-link">
                      <i
                        style="font-size: 16px;
          color: #666; cursor:pointer"
                        class="fas fa-pencil-alt"
                      ></i>
                    </button>
                    <button class="btn btn-link" @click="handleDeleteClick(campaign)">
                      <svgHelper name="delete"></svgHelper>
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
    <div
      class="modal fade add-user-modal"
      id="editCampaignModal"
      tabindex="-1"
      aria-labelledby="editCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">Edit Campaign</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeEdit"
              @click="resetModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input
                    disabled
                    id="editName"
                    type="text"
                    class="form-control"
                    v-model="editCampaignId"
                  />
                  <label style="text-transform: none!important;" for="editName">Campaign ID</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="editMedium"
                    type="text"
                    class="form-control"
                    v-model="editCampaignMedium"
                  />
                  <label for="editMedium">Medium</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="editCampaignName"
                    type="text"
                    class="form-control"
                    v-model="editCampaignCampaign"
                  />
                  <label for="editCampaignName">Description</label>
                </div>
                <div class="form-group m-label-left">
                  <input
                    id="editBudget"
                    type="text"
                    class="form-control"
                    v-model="editCampaignBudget"
                  />
                  <label style="text-transform: none!important;" for="editBudget"
                    >Budget [EUR]</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="updateCampaign()" type="button" class="btn btn-primary">
              Save
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="addCampaignModal"
      tabindex="-1"
      aria-labelledby="addCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addCampaignModalTitle">Add Campaign</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeAdd"
              @click="resetModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input
                    id="addCampaignid"
                    type="text"
                    class="form-control"
                    v-model="editCampaignId"
                  />
                  <label style="text-transform: none!important;" for="addCampaignid"
                    >Campaign ID</label
                  >
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="addcampaignMedium"
                    type="text"
                    class="form-control"
                    v-model="editCampaignMedium"
                  />
                  <label for="addcampaignMedium">Medium</label>
                </div>

                <div class="form-group m-label-left">
                  <input
                    id="addCampaignDesc"
                    type="text"
                    class="form-control"
                    v-model="editCampaignCampaign"
                  />
                  <label for="addCampaignDesc">Description</label>
                </div>
                <div class="form-group m-label-left">
                  <input
                    id="addcampaignbudget"
                    type="text"
                    class="form-control"
                    v-model="editCampaignBudget"
                  />
                  <label style="text-transform: none!important;" for="addcampaignbudget"
                    >Budget [EUR]</label
                  >
                </div>
                <div class="form-group m-label-left">
                  <input
                    id="addcampaignStartDate"
                    type="date"
                    class="form-control"
                    v-model="editCampaignStartDate"
                  />
                  <label for="addcampaignStartDate">Start Date</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="addCampaign()" type="button" class="btn btn-primary">
              Save
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade add-user-modal"
      id="deleteCampaignModal"
      tabindex="-1"
      aria-labelledby="deleteCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteCampaignModalTitle">Delete Campaign</h5>
            <button
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p class="text-center">
                  Please confirm that you want to delete <strong>{{ editCampaignId }}.</strong> This
                  action will permanently delete the information.
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="deleteCampaign()" type="button" class="btn btn-primary">
              Delete
            </button>

            <button
              @click="resetModal"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'Campaigns | Jobshark';
  },
  /*   description() {
    return 'Page description goes here.';
  }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/campaigns';
  },
  components: {},
  data: () => ({
    isLoading: false,
    searchWord: '',
    campaigns: [],

    editCampaignUUID: '',
    editCampaignId: '',
    editCampaignMedium: '',
    editCampaignCampaign: '',
    editCampaignBudget: '',
    editCampaignStartDate: '',
  }),
  methods: {
    getCampaigns() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/list`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.campaigns = res.data;
      });
    },

    addCampaign() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/create`, {
        method: 'post',
        data: {
          campaign_id: this.editCampaignId,
          campaign_medium: this.editCampaignMedium,
          campaign_name: this.editCampaignCampaign,
          campaign_budget: this.editCampaignBudget,
          campaign_start_date: this.editCampaignStartDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.resetModal();
          this.getCampaigns();
          this.$refs.closeAdd.click();
          this.$toasted.success('New campaign created', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to add new campaign', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    updateCampaign() {
      axios(`${process.env.VUE_APP_API_URL}/admin/campaign/update`, {
        method: 'post',
        data: {
          id: this.editCampaignUUID,
          campaign_medium: this.editCampaignMedium,
          campaign_name: this.editCampaignCampaign,
          campaign_budget: this.editCampaignBudget,
          campaign_start_date: this.editCampaignStartDate,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.getCampaigns();
          this.$refs.closeEdit.click();
          this.$toasted.success('Saved.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to edit campaign.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    deleteCampaign() {
      axios
        .delete(`${process.env.VUE_APP_API_URL}/admin/campaign/delete/${this.editCampaignUUID}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(() => {
          this.resetModal();
          this.getCampaigns();
          this.$refs.closeDelete.click();
          this.$toasted.success('Campaign Deleted.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(() => {
          this.$toasted.error('There was error while trying to delete campaign.', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },

    handleEditClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let editModal = new bootstrap.Modal(document.getElementById('editCampaignModal'));
        editModal.show();
      });
    },

    handleDeleteClick(campaign) {
      this.setForEdit(campaign);
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let deleteModal = new bootstrap.Modal(document.getElementById('deleteCampaignModal'));
        deleteModal.show();
      });
    },

    setForEdit(data, status) {
      this.editCampaignUUID = data.id;
      this.editCampaignId = data.campaign_id;
      this.editCampaignMedium = data.medium;
      this.editCampaignCampaign = data.campaign;
      this.editCampaignBudget = data.budget;
      this.editCampaignStartDate = data.start_date;
    },
    resetModal() {
      this.editCampaignUUID = '';
      this.editCampaignId = '';
      this.editCampaignMedium = '';
      this.editCampaignCampaign = '';
      this.editCampaignBudget = '';
      this.editCampaignStartDate = '';
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.getCampaigns();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: right;
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
